import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ClientesService } from 'src/app/services/clientes.service';

@Component({
  selector: 'app-v2seguimiento',
  templateUrl: './v2seguimiento.component.html',
  styleUrls: ['./v2seguimiento.component.scss']
})
export class V2seguimientoComponent implements OnInit {

  /** Timeline dinamico basado en los flags de AvanceCliente */
  public steps = [
    { key: 'paquete', label: 'Pedido enviado', completed: false },
    { key: 'marco', label: 'Toma de fotografia', completed: false },
    { key: 'color', label: 'Elige tu fotografia grupal', completed: false },
    { key: 'placa', label: 'Fecha de entrega', completed: false },
    { key: 'dedicatoria', label: 'Entregado', completed: false }
  ];

  /** Productos que regresan de /api/getPaqueteCliente/ */
  public resumen: any[] = [];
  public clienteId: number | null = null;
  public advertencia = '';

  constructor(private clientesService: ClientesService, private router: Router) {}

  ngOnInit(): void {
    if (!localStorage.getItem('token')) {
      this.router.navigate(['/cliente/inicio']);
      return;
    }
    this.loadClienteData();
  }

  /** Cargamos la informacion del cliente y actualizamos el timeline */
  private loadClienteData(): void {
    this.clientesService.getDataUsuario().subscribe({
      next: (response:any) => {
        if (response?.success) {
          this.clienteId = response.content.id;
          this.updateSteps(response.avances);
          this.advertencia = response.solicitado ? 'Tu pedido fue solicitado.' : 'Aun falta confirmar el pedido.';
          this.loadResumen();
        }
      },
      error: (error) => console.error('No se pudo obtener la informacion del cliente', error)
    });
  }

  /** Mapea los flags del backend contra los pasos visibles en pantalla */
  private updateSteps(avances: any): void {
    if (!avances) {
      return;
    }
    this.steps = this.steps.map((step) => ({
      ...step,
      completed: avances[step.key] === 1
    }));
  }

  /** Consulta /api/getPaqueteCliente/ para mostrar el resumen */
  private loadResumen(): void {
    if (!this.clienteId) {
      return;
    }
    this.clientesService.getPaqueteCliente({ cliente: this.clienteId }).subscribe({
      next: (response:any) => {
        if (response?.success) {
          this.resumen = response.content.paquetes || [];
        }
      },
      error: (error) => console.error('No se pudo cargar el resumen del paquete', error)
    });
  }

}
